export const routes = {
  start: "/",
  help: "/help",
  components: "/components",
  main: "/main",
};
